<script setup lang="ts">
import { ref } from 'vue';
import { useModalStore } from '../../ui/modal/modal-store';
import type { EmptyCallback } from '../../utils/global-types';
import { downloadFile } from '../../utils/helpers';

const modal = useModalStore();
const props = defineProps<{
    filename: string,
    blob: Blob,
    title: string,
    height?: number,
    callback?: EmptyCallback
}>();

function download() {
    downloadFile(props.blob, props.filename);
}

function cancel() {
    if (url.value) {
        URL.revokeObjectURL(url.value);
    }

    modal.cancel()

    if (props.callback) {
        props.callback()
    }
}

const url = ref<string | null>(null);
url.value = URL.createObjectURL(props.blob)

</script>
<template>
    <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" @click="cancel">
            <i class="fas fa-times"></i>
        </button>
        <h4 class="modal-title">{{ title }}</h4>
    </div>
    <div class="modal-body" v-if="url">
        <PdfObject :url="url" style="min-width: 60rem; width: 100%;"
            :options="{ height: height ? `${height}px` : 'calc(100vh - 10rem)' }">
            Browser preview not supported <a @click="download" role="button">Download PDF</a>.
        </PdfObject>
    </div>
</template>